import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import ProjectCard from './ProjectCards'
import Particle from '../Particle'
import affricoomerce from '../../Assets/Projects/affricoomerce.png'
import atoovis from '../../Assets/Projects/atoovis.png'
import realstate from '../../Assets/Projects/realstate.png'
import articleIdea from '../../Assets/Projects/articleIdea.png'
import suicide from '../../Assets/Projects/suicide.png'
import bitsOfCode from '../../Assets/Projects/blog.png'
import mefamart from '../../Assets/Projects/mefamart.png'

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: 'white' }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={atoovis}
              isBlog={false}
              title="Atoovis"
              description="Atoovis is an e-commerce platform that provide  serve as a link between buyers and verified. Since it's a private project I can't say much about it but your can check the demo link attached"
              ghLink="#"
              demoLink="https://atoovis.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={realstate}
              isBlog={false}
              title="Realtor"
              description="Realtor is an app i buld with NextJs using the Buyout API. Realtor allow foreigners to connect with real estate agencies in Dubai and check the cost of rent or purchase price of different apartment."
              ghLink="https://github.com/iamkelv/Real-Estate-app"
              demoLink="https://real-estate-nine-gamma.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={articleIdea}
              isBlog={false}
              title="Article Idea generator"
              description="Article Idea generator is an AI application powered by openAI API that allows writers to generate article topic and is search engine friendly. This app is was build using NextJs and the Backend was using NodeJS. This app is an open souce and have over 2k users. "
              ghLink="https://github.com/Olanetsoft/article-idea-generator/"
              demoLink="https://www.articleideagenerator.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={affricoomerce}
              isBlog={false}
              title="Affricommerce"
              description="Affricommerce is a SaaS open source e-commerce platform that allow local store owners to own an online store. This app is still on development"
              ghLink="https://github.com/africommerce/africommerce-saas"
              demoLink="https://africommerce-saas.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mefamart}
              isBlog={false}
              title="Mefamart "
              description="Mefamart is shopping platform which was my final exam Project. The main goal was to manipulate the https://dummyjson.com api "
              ghLink="https://github.com/iamkelv/third-semester"
               demoLink="https://third-semester-dusky.vercel.app/login"

            />
          </Col>
          {/*
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  )
}

export default Projects
